<template>
    <transition name="fade">
      <div @mousedown="clickOnOutside" v-show="modal" class="modal" @keydown.esc="closeOnEsc" tabindex="-1">
        <transition name="appear" appear mode="out-in">
          <div
            @mousedown.stop
            class="modal-dialog"
            :class="{ 'modal-dialog--full-screen-on-mobile': this.fullScreenOnMobile }"
            :style="customStyles"
            :key="modalId"
            v-if="modal"
          >
            <button v-if="hasCloseButton" class="modal-close" @click="close">
              <img class="modal-close__icon" src="@/assets/global-icons/cross-white-circle.svg" />
            </button>

            <div class="modal-dialog-content">
              <!-- <newModalHeader :inRoot="true"/> -->

              <component @modalSettings="onModalSettings" :is="modal.component" v-bind="modal.props" ref="componentInstance" />
            </div>
          </div>
        </transition>
      </div>
    </transition>
</template>

<script>

import newModalHeader from './newModalHeader.vue';

const defaultModalSettings = {
  closeOnClickOutside: false,
  styles: {},
  fullScreenOnMobile: true,
  hasCloseButton: true
};

export default {
  components: { newModalHeader },
  data() {
    return {
      // These are passed up from the child component via modalSettings event
      modalSettings: defaultModalSettings,
      transitioning: false,
    };
  },
  methods: {
    close() {
      this.$store.dispatch('modal/close');
    },
    clickOnOutside() {
      if (this.modalSettings.closeOnClickOutside) {
        this.close();
      }
    },
    closeOnEsc() {
      this.close();
    },
    onModalSettings(settings) {
      this.modalSettings = {
        ...this.modalSettings,
        ...settings
      };
    },
    focusModal() {
      this.$nextTick(() => this.$el.focus())
    }
  },
  computed: {
    modal: (vm) => vm.$store.getters['modal/modal'],
    modalId: (vm) => vm.$store.getters['modal/modalId'],
    customStyles() {
      return this.modalSettings.styles;
    },
    fullScreenOnMobile() {
      return this.modalSettings.fullScreenOnMobile;
    },
    hasCloseButton() {
      return this.modalSettings.hasCloseButton;
    }
  },
  watch: {
    modal() {
      this.modalSettings = defaultModalSettings;
      this.focusModal()
    }
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.appear-enter-active,
.appear-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.appear-enter-to, .appear-leave-from {
  transform: scale(1);
  opacity: 1;
}

.appear-enter,
.appear-leave-to {
  transform: scale(0.95);
  opacity: 0;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9997;
  background: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;

  &-close {
    position: absolute;
    top: 15px;
    right: 15px;
    padding: 15px;
    background: none;
    cursor: pointer;
    border: none;

    &__icon {
      height: 30px;
      width: 30px;
      display: block;
    }
  }

  &-dialog {
    min-width: 450px;
    width: 50vw;
    max-width: 600px;
    overflow-x: hidden;

    max-height: 100%;
    overflow-y: auto;

    border-radius: 17px;
    background: $grey-4;
    color: white;
    position: relative;

    &--full-screen-on-mobile {
      @include mobile-only {
        $height: calc(100% - #{$sidebar-width});
        height: $height;
        max-height: $height;
        width: 100%;
        min-width: 0;
        max-width: 100%;
        border-radius: 0;
        align-self: flex-start;
      }
    }

    &-content {
      padding: 30px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
